import { render, staticRenderFns } from "./PictureView.vue?vue&type=template&id=c67ab262&scoped=true&"
import script from "./PictureView.vue?vue&type=script&lang=js&"
export * from "./PictureView.vue?vue&type=script&lang=js&"
import style0 from "./PictureView.vue?vue&type=style&index=0&id=c67ab262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67ab262",
  null
  
)

export default component.exports